export const menuArr = [
  {
    generalName: "Paste",
    list: [
      {
        id: "00",
        selected: false,
        name: "Special Pasta",
        price: "10",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/special_pasta.jpg",
      },
      {
        id: "01",
        selected: false,
        name: "Small Pasta",
        price: "3",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/small_pasta.jpg",
      },
      {
        id: "02",
        selected: false,
        name: "Medium Pasta",
        price: "5",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/medium_pasta.jpg",
      },
      {
        id: "03",
        selected: false,
        name: "Big Pasta",
        price: "8",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/big_pasta.jpg",
      },
    ],
  },
  {
    generalName: "Burger",
    list: [
      {
        id: "04",
        selected: false,
        name: "Special Burger",
        price: "10",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/special-burger.jpg",
      },
      {
        id: "05",
        selected: false,
        name: "Small Burger",
        price: "3",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/small_burger.jpg",
      },
      {
        id: "06",
        selected: false,
        name: "Medium Burger",
        price: "5",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/medium_burger.jpg",
      },
      {
        id: "07",
        selected: false,
        name: "Big Burger",
        price: "8",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/big_burger.webp",
      },
    ],
  },
  {
    generalName: "Pizza",
    list: [
      {
        id: "08",
        selected: false,
        name: "Special Pizza",
        price: "10",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/special_pizza1.jpg",
      },
      {
        id: "09",
        selected: false,
        name: "Small Pizza",
        price: "3",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/small-pizza1.jpg",
      },
      {
        id: "10",
        selected: false,
        name: "Medium Pizza",
        price: "5",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/medium_pizza.jpg",
      },
      {
        id: "11",
        selected: false,
        name: "Big Pizza",
        price: "8",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/big-pizza.jpg",
      },
    ],
  },
  {
    selected: false,
    generalName: "OTHER FOOD MENU",
    list: [
      {
        id: "12",
        selected: false,
        name: "Fried Rice",
        price: "5",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/fried_rice.jpg",
      },
      {
        id: "13",
        selected: false,
        name: "Jollof Rice",
        price: "7",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/joolof_rice.png",
      },
      {
        id: "14",
        selected: false,
        name: "Eba & Egusi",
        price: "2",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/eba.jpg",
      },
      {
        id: "15",
        selected: false,
        name: "Amala & Gbegiri",
        price: "10",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/amala.png",
      },
      {
        id: "16",
        selected: false,
        name: "Agoyin Beans",
        price: "12",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/agoyin_beans.jpg",
      },
      {
        id: "17",
        selected: false,
        name: "Yellow Rice",
        price: "2",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/yellow_rice.jpg",
      },
      {
        id: "18",
        selected: false,
        name: "Hausa Tuwo",
        price: "2",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/tuwo.jpg",
      },
      {
        id: "19",
        selected: false,
        name: "Semovita & Egusi",
        price: "7",
        description:
          "This comes straight from gradma's recipe book, evry last ingrdient has been sourced and is as authentic as can be imagined.",
        image: "images/menuImages/semo.jpg",
      },
    ],
  },
];
